define('presentation/signup/viewModels/signupForCustomerViewModel',[
        'businessServices/signup/signupSessionStore',
        'common/promises/promiseFactory',
        'presentation/common/actionModal/viewModels/actionModalViewModel',
        'presentation/signup/viewModels/signupForCustomerModalViewModel'
    ],
    function() {
        return function() {
            const self = this;

            const PromiseFactoryConstructor = require('common/promises/promiseFactory');
            const _promiseFactory = new PromiseFactoryConstructor();

            const SignupForCustomerModalConstructor = require('presentation/signup/viewModels/signupForCustomerModalViewModel');
            const SignupSessionStoreConstructor = require('businessServices/signup/signupSessionStore');

            let _signupSessionStore = null;

            self.actionModal = null;

            self.affiliate = ko.observable('-');
            self.hubSpotContactRecordId = ko.observable('-');
            self.patLiveAccountNumber = ko.observable('-');

            self.editSignupForCustomer = () => {
                _buildEditSignupForCustomerModal();
                self.actionModal.showModal()
                    .done(_refreshSignupForCustomer);
            };

            const _buildEditSignupForCustomerModal = () => {
                self.actionModal
                    .clearModal()
                    .setContentViewModel(SignupForCustomerModalConstructor)
                    .setHeaderText({i18n: 'signupForCustomerModal:headerText'})
                    .shouldDisplaySubmitButton(false)
                    .setCancelButtonText({i18n: {key: 'close'}});

            };

            const _refreshSignupForCustomer = () => {
                return _promiseFactory.defer(promise => {
                    _signupSessionStore.get(false)
                        .fail(promise.reject)
                        .done(signupDocument => {
                            if (signupDocument === null) {
                                promise.resolve();
                                return;
                            }

                            _setAffiliate(signupDocument)
                                .done(() => {
                                    const hubSpotContactRecordId = signupDocument.hubSpotContactRecordId;
                                    self.hubSpotContactRecordId(hubSpotContactRecordId ? hubSpotContactRecordId : "-");
                                    const patLiveAccountNumber = signupDocument.patLiveAccountNumber;
                                    self.patLiveAccountNumber(patLiveAccountNumber ? patLiveAccountNumber : "-");
                                    promise.resolve();
                                });
                        });
                });
            };

            const _setAffiliate = (signupDocument) => {
                return _promiseFactory.defer(promise => {
                    _signupSessionStore.getAffiliates()
                        .fail(promise.reject)
                        .done((result) => {
                            const affiliate = result.affiliates.find((affiliate) => {
                                return affiliate.affiliateCode === signupDocument.affiliateId;
                            });
                            self.affiliate(affiliate ? affiliate.affiliateName : "-");
                            promise.resolve();
                        });
                });
            };

            self.activate = () => {
                _signupSessionStore = new SignupSessionStoreConstructor();
                _signupSessionStore.init();

                const ActionModalViewModelConstructor = require('presentation/common/actionModal/viewModels/actionModalViewModel');
                self.actionModal = new ActionModalViewModelConstructor();

                return _initialize();
            };

            const _initialize = () => {
                _refreshSignupForCustomer();
                _promiseFactory.wait();
            };
        };
    });
